import { chatListHeaderItemHeight_TW, LIST_ITEM_HEIGHT } from 'flow/flow-theme';
import { ChatSessionKey, ExtensionKey } from 'flow/types/EntityKeys';
import { EMPTY_BUBBLE_HEIGHT } from '../empty-states/EmptyBubble';

export type ChatListRow =
    | { kind: 'overview' }
    | { kind: 'meetings' }
    | { kind: 'chatSession'; chatSessionKey: ChatSessionKey }
    | { kind: 'noChatSessions' }
    | { kind: 'skeleton'; index: number }
    | { kind: 'newChatTitle' }
    | { kind: 'newChat'; extensionKey: ExtensionKey }
    | { kind: 'sms'; searchText: string };

export const chatListRowHeight = (row: ChatListRow) => {
    switch (row.kind) {
        case 'noChatSessions':
            return EMPTY_BUBBLE_HEIGHT;
        case 'newChatTitle':
            return chatListHeaderItemHeight_TW;
        default:
            return LIST_ITEM_HEIGHT;
    }
};

// react-window keys each row element by this key, and the Tab stop names its
// row by it. So the element, its focus and the Tab stop follow one chat.
export const chatListRowKey = (row: ChatListRow) => {
    switch (row.kind) {
        case 'overview':
            return 'central-switch-overview';
        case 'meetings':
            return 'meetings';
        case 'chatSession':
            return row.chatSessionKey;
        case 'noChatSessions':
            return 'empty-bubble';
        case 'skeleton':
            return `chat-skeleton-${row.index}`;
        case 'newChatTitle':
            return 'Chat.Section.Start.New';
        case 'newChat':
            return row.extensionKey;
        case 'sms':
            return 'sms-item';
    }
};

export const rowIsFocusable = (row: ChatListRow) => {
    switch (row.kind) {
        case 'noChatSessions':
        case 'skeleton':
        case 'newChatTitle':
            return false;
        default:
            return true;
    }
};
